module.exports = __webpack_public_path__ + "img/tp2.7edb4a5d.png";